export default __webpack_public_path__ + "static/media/IconDesc_Heatsink.256.bfc29e53.png";